import Messenger from '@/api/messenger'

const initLoad = commit => commit('changeLoading', { isLoading: true })

const onError = (commit, { error }) => {
  commit('changeLoading', { isLoading: false })
  throw error
}

const addMessage = ({ commit, getters }, { message }) => {
  const existingMessage = getters.collection[message._id]
  commit('updateItem', { item: message })
  if (!existingMessage) {
    commit('appendItem', {
      item: message,
      scope: {
        conversationId: message.conversation,
        page: 1
      }
    })
  }
}

export default {
  fetchPerPage: ({ commit, dispatch }, { page, conversationId }) => {
    initLoad(commit)
    return Messenger.messages({ page, conversationId })
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: { page, conversationId }
        })
        return Promise.all(data
          .filter(e => !e.receivedAt)
          .map(e => dispatch('markAsReceived', { id: e._id }))
        )
      })
      .then(_ => commit('changeLoading', { isLoading: false }))
      .catch(error => onError(commit, { error }))
  },
  fetchPending: ({ commit, dispatch, rootGetters }) => {
    initLoad(commit)
    return Messenger.fetchPending({ userId: rootGetters['skiliko/session/currentUser'].chatable_id })
      .then(({ data }) => {
        commit('updateCollection', { collection: data })
        return Promise.all(data
          .filter(e => !e.receivedAt)
          .map(e => dispatch('markAsReceived', { id: e._id }))
        )
      })
      .then(_ => commit('changeLoading', { isLoading: false }))
      .catch(error => onError(commit, { error }))
  },
  create: ({ commit, getters, rootGetters }, { query, content, data, conversationId }) => {
    initLoad(commit)
    const from = rootGetters['skiliko/session/currentUser'].chatable_id
    return Messenger.sendMessage({
      from,
      query,
      data,
      content,
      conversationId
    })
      .then(({ data }) => {
        addMessage({ commit, getters }, { message: data })
        commit('changeLoading', { isLoading: false })
        return data
      })
      .catch(error => onError(commit, { error }))
  },
  markAsReceived: ({ commit, getters, rootGetters }, { id }) => {
    const message = getters.collection[id]
    if (message.to._id !== rootGetters['skiliko/session/currentUser'].chatable_id) { return }
    if (getters.collection[id].receivedAt) { return }
    const receivedAt = new Date()
    commit('updateItem', {
      item: {
        _id: id,
        receivedAt
      }
    })
    return Messenger.markAsReceived({
      id,
      user: rootGetters['skiliko/session/currentUser'].chatable_id,
      receivedAt
    })
  },
  markAsRead: ({ commit, getters, rootGetters }, { ids }) => {
    const validIds = ids
      .map(id => getters.collection[id])
      .filter(m => !m.readAt)
      .filter(m => m.to._id === rootGetters['skiliko/session/currentUser'].chatable_id)
      .map(m => m._id)
    const readAt = new Date()
    if (!validIds.length) { return }
    validIds.forEach(id => commit('updateItem', {
      item: {
        _id: id,
        readAt
      }
    }))
    return Messenger.markAsRead({
      ids: validIds,
      user: rootGetters['skiliko/session/currentUser'].chatable_id,
      readAt
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/messages/actions.js